import React, { useState, useEffect } from 'react';
import Calendar from './Calendar';
import ItemList from './ItemList';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Snackbar, Alert, Modal, Box, Typography, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import './Campaign.css';
import { baseURL } from '../Constant';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2
};

//confirmation helper array
const dialogArr = [{
  title: "",
  text: "",
  action: ""
},
//not possible to use this
{
  title: " Are you sure you want to submit the request?",
  text: "Once the request is submitted, it can not be edited.",
  action: "Submitted for Review"
}, {
  title: " Are you sure you want to approve the request?",
  text: "Once the request is approved, it can not be declined or put on hold.",
  action: "Approved"
}, {
  title: " Are you sure you want to decline the request?",
  text: "Once the request is declined, you wont be able to perform any further actions on it.",
  action: "Declined"
}, {
  title: " Are you sure you want to Finalize the request?",
  text: "Once the request is finalized, you wont be able to perform any further actions on it.",
  action: "Finalized"
}, {
  title: " Are you sure you want to put this request on hold?",
  text: "Once the request is put on hold, you wont be able to perform any further actions on it(except Decline).",
  action: "On Hold"
}];

//utils
const weekAhead = () => {
  let todayPlusWeek = new Date();
  let workingDays = 0;

  // Increment the date until 5 working days are added
  while (workingDays < 5) {
    todayPlusWeek.setDate(todayPlusWeek.getDate() + 1);

    // Only count weekdays (Monday to Friday)
    if (todayPlusWeek.getDay() >= 1 && todayPlusWeek.getDay() <= 5) {
      workingDays++;
    }
  }

  // Return formatted 'YYYY-MM-DD' string
  return todayPlusWeek.toISOString().split("T")[0];
};
function getSubstringAfterFiveHyphens(str) {
  const parts = str.split('-');
  if (parts.length > 5) {
    return parts.slice(6).join('-');
  } else {
    console.log("Not enough hyphens in the string");
  }
}
const Campaign = ({
  campaignMetaData,
  approvalView,
  setFlag
}) => {
  const planItems = [{
    id: '1',
    title: 'Registration Start'
  }, {
    id: '2',
    title: 'Registration End'
  }, {
    id: '3',
    title: 'Kick-off Call'
  }, {
    id: '4',
    title: 'Learning Journey Start'
  }, {
    id: '5',
    title: 'Learning Quiz/Assessment/Exam'
  }, {
    id: '6',
    title: 'Learning Journey End'
  }];
  const commItems = [{
    id: '7',
    title: 'Teaser Mailer'
  }, {
    id: '8',
    title: 'Launch/Nomination/Registration Mailer'
  }, {
    id: '9',
    title: 'Invite Mailer'
  }, {
    id: '10',
    title: 'Follow-up/Reminder Mailer'
  }, {
    id: '11',
    title: 'Nudge Mailer'
  }, {
    id: '12',
    title: 'Recognition Mailer'
  }, {
    id: '13',
    title: 'Closure/Highlights Mailer'
  }, {
    id: '14',
    title: 'Social Engagement'
  }, {
    id: '15',
    title: 'Endorsements'
  }, {
    id: '16',
    title: 'Motion Graphics'
  }, {
    id: '17',
    title: 'Print'
  }];
  let resultantItemsArray = approvalView ? commItems : planItems;
  const [items, setItems] = useState(resultantItemsArray);
  const [loading, setLoading] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);
  const [file, setFile] = useState(null);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [openAlert, setOpenAlert] = useState(0);
  const [enableBtns, setEnableBtns] = useState(false);
  const [fixedItems, setFixedItems] = useState([]); //will map start date and end date o calendar.
  const [isPaused, setIsPaused] = useState(false);
  const [isConcluded, setConcluded] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [open, setOpen] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(0);
  const [editDates, setEditDates] = useState(false); // this will open/close modal for start&end Dates edit. 
  const [resume_formData, setFormData] = useState({
    startDate: formatToIST(campaignMetaData.startDate),
    endDate: formatToIST(campaignMetaData.endDate)
  });
  const [edit_formData, setEditFormData] = useState({
    startDate: '',
    endDate: ''
  });
  function formatToIST(dateString) {
    // Parse the incoming date string
    const date = new Date(dateString);

    // Get the time offset for IST (Indian Standard Time is UTC + 5:30)
    const istOffset = 5.5 * 60 * 60 * 1000; // Convert hours to milliseconds

    // Adjust the date to IST
    const istDate = new Date(date.getTime() + istOffset);

    // Extract year, month, and day from the IST date
    const year = istDate.getUTCFullYear();
    const month = String(istDate.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(istDate.getUTCDate()).padStart(2, '0');

    // Return the date in "YYYY-MM-DD" format
    return `${year}-${month}-${day}`;
  }
  function formatDateShort(dateString) {
    const date = new Date(dateString); // Convert string to Date object

    // Use Intl.DateTimeFormat to format the date
    const formatter = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    return formatter.format(date); // Returns the date in DD/MM/YYYY format
  }
  function calculateDateDifference(dateA, dateB) {
    const dateAObj = new Date(dateA);
    const dateBObj = new Date(dateB);
    const differenceMs = Math.abs(dateAObj.getTime() - dateBObj.getTime());
    const differenceDays = differenceMs / (1000 * 60 * 60 * 24);
    return differenceDays;
  }

  //resume campaign form
  const handleChange = event => {
    setFormData({
      ...resume_formData,
      [event.target.name]: event.target.value
    });
  };
  const handleResumeFormSubmit = e => {
    e.preventDefault();
    if (resume_formData.startDate < campaignMetaData.startDate) {
      alert("new Start Date cannot be earlier than the prev start date!");
    } else {
      const diffInDays = calculateDateDifference(resume_formData.startDate, campaignMetaData.startDate);
      const updatedItems = selectedItems.map(item => {
        const currentDate = new Date(item.date);
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + diffInDays);
        return {
          ...item,
          date: newDate.toISOString()
        };
      });
      setSelectedItems(updatedItems);
      //this is only for UI actual saving of new dates will take place later
      setFixedItems([{
        ...fixedItems[0],
        date: resume_formData.startDate
      }, {
        ...fixedItems[1],
        date: resume_formData.endDate
      }]);

      // Close modal after submission
      setOpen(false);
      setIsPaused(false);
    }
  };

  //tackle resume with old dates
  const tackleRWOD = () => {
    setFormData({
      startDate: formatToIST(campaignMetaData.startDate),
      endDate: formatToIST(campaignMetaData.endDate)
    });
    setOpen(false);
    setIsPaused(false);
  };
  const tackleCancelResume = () => {
    setFormData({
      startDate: formatToIST(campaignMetaData.startDate),
      endDate: formatToIST(campaignMetaData.endDate)
    });
    setOpen(false);
  };

  //=======Edit Form
  const handleEditFormChange = e => {
    setEditFormData({
      ...edit_formData,
      [e.target.name]: e.target.value
    });
  };
  const tackleCancelEdit = () => {
    setEditFormData({
      startDate: '',
      endDate: ''
    });
    setEditDates(false);
  };
  const handleEditFormSubmit = () => {
    setFixedItems([{
      ...fixedItems[0],
      date: edit_formData.startDate
    }, {
      ...fixedItems[1],
      date: edit_formData.endDate
    }]);
    campaignMetaData.startDate = edit_formData.startDate;
    campaignMetaData.endDate = edit_formData.endDate;
    setEditDates(false);
  };
  useEffect(() => {
    if (campaignMetaData.status === undefined || campaignMetaData.status === 'Saved as Draft') setEnableBtns(true);else if (campaignMetaData.status === 'On Hold') {
      setIsPaused(true);
      setEnableBtns(true);
    } else if (campaignMetaData.status === 'Declined' || campaignMetaData.status === 'Finalized') {
      setConcluded(campaignMetaData.status);
    } else if (campaignMetaData.status === 'Approved') setIsApproved(true);
    setFixedItems([{
      id: '-1',
      title: 'Campaign Start',
      date: campaignMetaData.startDate,
      editable: false,
      backgroundColor: '#460073',
      className: 'fixed'
    }, {
      id: '-2',
      title: 'Campaign End',
      date: campaignMetaData.endDate,
      editable: false,
      backgroundColor: '#460073',
      className: 'fixed'
    }]);
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseURL}/campaign/${campaignMetaData.id}`);
        if (response.status === 200) {
          if (approvalView && response.data[0].ac_selectedItems?.length > 0) {
            setSelectedItems(response.data[0].ac_selectedItems); //ac_selectedItems= approver's copy of selected Items
          } else {
            if (response.data[0].selectedItems?.length > 0) setSelectedItems(response.data[0].selectedItems);
          }
        }
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (campaignMetaData.id > 0) fetchData();else {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    const handleBeforeUnload = event => {
      if (unsavedChanges) {
        event.preventDefault();
        // Older browsers require a returnValue for custom messages
        event.returnValue = "Are you sure you want to leave? You have unsaved changes!";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [unsavedChanges]);
  const onEventDrop = (droppedItemId, date) => {
    const selectedItem = items.find(item => item.id === droppedItemId);
    if (selectedItem) {
      const iD = ["5", "10", "12", "16", "11", "14"].includes(droppedItemId) ? droppedItemId + "_-" + uuidv4().slice(4) :
      //repeatable items
      droppedItemId; // Non-repeatable items
      const newItem = {
        id: iD,
        title: selectedItem.title,
        date: date,
        className: approvalView ? "approver" : "requestor"
      };
      setSelectedItems(prevSelectedItems => {
        const updatedItems = prevSelectedItems.filter(item => item.id !== iD);
        return [...updatedItems, newItem];
      });
      setUnsavedChanges(true);
    }
  };
  const onEventReschedule = (itemID, newDate) => {
    const updatedItems = selectedItems.map(item => {
      if (item.id === itemID) {
        return {
          ...item,
          date: newDate
        };
      }
      return item;
    });
    setSelectedItems(updatedItems);
    setUnsavedChanges(true);
  };
  const handleAction = status => {
    setUnsavedChanges(false);
    if (approvalView) approversUpdateInDB(status);else {
      if (campaignMetaData.id < 0) saveDataInDB(status);else updateDataInDB(status);
    }
  };
  const saveDataInDB = async status => {
    const formData = new FormData();
    campaignMetaData.status = status;
    formData.append('campaignMetaData', JSON.stringify(campaignMetaData));
    formData.append('selectedItems', JSON.stringify(selectedItems));
    formData.append("file", file);
    try {
      const response = await axios.post(`${baseURL}/campaign`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.status === 200) {
        setAlertMessage(`${status} Successfully!`);
        setAlertSeverity('success');
        setUnsavedChanges(false);
        setFlag(prevFlag => prevFlag + 1);
        if (status === 'Submitted for Review') {
          setOpenAlert(2);
          setEnableBtns(false);
        } else if (status === 'Saved as Draft') {
          setOpenAlert(1);
          campaignMetaData.id = response.data.newId;
        }
      }
    } catch (error) {
      console.log(error);
      setAlertMessage('An error occurred: ' + error.message);
      setAlertSeverity('error');
      if (status === 'Submitted for Review') setOpenAlert(2);else setOpenAlert(1);
    }
  };
  const updateDataInDB = async status => {
    const formData = new FormData();
    formData.append('selectedItems', JSON.stringify(selectedItems));
    formData.append('updatedStatus', status);
    formData.append("file", file);
    if (campaignMetaData.status === 'On Hold') {
      formData.append('prevStatus', 'On Hold');
      formData.append('newStartDate', resume_formData.startDate);
      formData.append('newEndDate', resume_formData.endDate);
    } else if (edit_formData.startDate && edit_formData.endDate) {
      formData.append('edittedStartDate', edit_formData.startDate);
      formData.append('edittedEndDate', edit_formData.endDate);
    }
    try {
      const response = await axios.put(`${baseURL}/campaign/${campaignMetaData.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (response.status === 200) {
        setAlertMessage(`${status} Successfully!`);
        setAlertSeverity('success');
        setUnsavedChanges(false);
        if (status === 'Submitted for Review') {
          setEnableBtns(false);
          setOpenAlert(2);
        } else setOpenAlert(1);
      }
    } catch (error) {
      console.log(error);
      setAlertMessage('An error occurred: ' + error.message);
      setAlertSeverity('error');
      if (status === 'Submitted for Review') {
        setOpenAlert(2);
      } else setOpenAlert(1);
    }
  };
  const approversUpdateInDB = async status => {
    //TODO
    const formData = new FormData();
    formData.append('updatedStatus', status);
    if (status === 'Review Saved') {
      formData.append('ac_selectedItems', JSON.stringify(selectedItems));
    } else if (status === 'Approved') {
      formData.append('selectedItems', JSON.stringify(selectedItems));
    }
    try {
      const response = await axios.put(`${baseURL}/campaign/${campaignMetaData.id}`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.status === 200) {
        setAlertMessage(`${status === "Review Saved" ? "Review changes Saved" : status} Successfully!`);
        setAlertSeverity('success');
        setOpenAlert(1);
        setUnsavedChanges(false);
        // setFlag((prevFlag) => prevFlag + 1);
        if (status === 'On Hold') setIsPaused(true);else if (status === 'Declined' || status === 'Finalized') setConcluded(status);else if (status === 'Approved') setIsApproved(true);
      }
    } catch (error) {
      console.log(error);
      setAlertMessage('An error occurred: ' + error.message);
      setAlertSeverity('error');
      setOpenAlert(1);
    }
  };
  return <>
      {loading ? <h2>Loading...</h2> : <div>

          <Snackbar open={openAlert === 1} autoHideDuration={3000} anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }} onClose={() => setOpenAlert(0)}>
            <Alert severity={alertSeverity}>{alertMessage}</Alert>
          </Snackbar>   
            <Snackbar open={openAlert === 2} autoHideDuration={3000} anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }} onClose={() => setOpenAlert(0)}>
              <Alert severity={alertSeverity} sx={{
          width: '400px',
          fontSize: '1.2rem',
          padding: '20px'
        }}>
                <Typography variant="h6" sx={{
            fontWeight: 'bold'
          }}>
                {alertSeverity === 'error' ? "Error" : "The Campaign Request submitted successfully!"}
                </Typography>
                <Typography variant="body1">
                {alertSeverity === 'error' ? alertMessage : `You can check the status of this request under "Mycontent" Option`}
                </Typography>
              </Alert>
            </Snackbar>      
          
          <div className="campaign migrated-style-campaign-8d1d2c-1">
            <div className="itemList">            
              <ItemList items={items} setItems={setItems} />
              {/* {approvalView ||!enableBtns?
               <div style={{textDecoration:"underline"}}><em>{campaignMetaData?.fileUrl?getSubstringAfterFiveHyphens(campaignMetaData.fileUrl):"No document attached"}</em></div>:
               <>
               {campaignMetaData?.fileUrl && file==null?
                <div>
                <div
                style={{display:"inline-block",width:"85%",margin:"auto",textDecoration:"underline",
                  fontSize:"14px",padding:"3px",whiteSpace:"nowrap",overflowX:"auto", 
                    scrollbarWidth: "none",
                    msOverflowStyle: "none"
                }}>
                <em>{getSubstringAfterFiveHyphens(campaignMetaData.fileUrl)}</em>
               </div>
                <input
               type="file"
               accept="image/*,.pdf,.doc,.docx"
               name="file-attachment" id="fileUpdate"
               style={{ display: 'none' }}
               onChange={(e)=>setFile(e.target.files[0])}
               />
               <label htmlFor="fileUpdate" style={{cursor:"pointer"}}>  <EditIcon fontSize="small"/>              
               </label>
               </div>:
                <div 
               style={{height:"2em", width:"100%",margin:"auto"}}
               >
               <div className="fileChooser">
               <input
               type="file"
               accept="image/*,.pdf,.doc,.docx"
               name="file-attachment" id="fileInput"
               style={{ display: 'none' }}
               onChange={(e)=>setFile(e.target.files[0])}
               />
               <label htmlFor="fileInput" >
                  <> 
                    <img height="16px" src={process.env.PUBLIC_URL + "/Images/Upload_icon.png"} />
                    <strong> Upload Document</strong>
                  </>
               </label>
               <>
               <instruct 
               style={{fontSize:"14px",padding:"3px", width:"150px",whiteSpace:"nowrap",overflowX:"auto", 
                scrollbarWidth: "none",
                msOverflowStyle: "none"
               }}>
               {file == null ?"No File Selected"
               :file?.name
               }
               </instruct>
               </>
               </div>
               <span style={{color:"#666666",fontSize:"0.7em"}}><strong>Note:</strong> File size should be less than 3MB.</span>
               </div>
               }
               </>
               } */}
            </div>
            <div className="Calendar">
              <Calendar approvalView={approvalView} fixedDates={{
            start: formatDateShort(fixedItems[0].date),
            end: formatDateShort(fixedItems[1].date)
          }} items={fixedItems.concat(selectedItems)} onEventDrop={onEventDrop} onEventReschedule={onEventReschedule} setSelectedItems={setSelectedItems} setUnsavedChanges={setUnsavedChanges} // Correct assignment
          />
            </div>
          </div>
          <Dialog open={openConfirmation > 0} onClose={() => setOpenConfirmation(0)}>   
        <DialogTitle>{dialogArr[openConfirmation].title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogArr[openConfirmation].text}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmation(0)} color="primary">Cancel</Button>
          <Button onClick={() => {
            handleAction(dialogArr[openConfirmation].action);
            setOpenConfirmation(0);
          }} color="primary" autoFocus>Confirm</Button>
        </DialogActions>
      </Dialog>



        {isConcluded ? <div className='HoldScreen-container'>
         <h2 className='HoldScreen-title center'>This Campaign has been {isConcluded}!</h2>
          {isConcluded !== "Declined" && <div className='center'>
            <button className='outlined-btn' onClick={() => setOpenConfirmation(3)}>Decline</button> 
          </div>}
        </div> : isPaused ? <div className='HoldScreen-container'>
          <h2 className='HoldScreen-title center'>This Campaign has been put On Hold</h2>
          <div className='center'>
          {approvalView ? <button className='outlined-btn' onClick={() => setOpenConfirmation(3)}>Decline</button> : <button className='filled-btn' onClick={() => setOpen(true)}>Resume</button>}
          </div>
          <Modal open={open} onClose={() => setOpen(false)}>
          <Box sx={style}>
            <Typography variant="h6" component="h2" sx={{
              fontFamily: "Graphik-Regular"
            }}>
              Enter New dates to Resume
            </Typography>
            
            <form onSubmit={handleResumeFormSubmit} className="migrated-style-campaign-8d1d2c-2">
              <div className="migrated-style-campaign-8d1d2c-3">
              <div className="migrated-style-campaign-8d1d2c-4">
            <Typography sx={{
                    fontSize: "14px"
                  }}>Start Date</Typography>
              <TextField name="startDate" type="date" value={resume_formData.startDate} onChange={handleChange} InputProps={{
                    inputProps: {
                      min: formatToIST(campaignMetaData.startDate)
                    }
                  }} margin="normal" required />
              </div>
              <div className="migrated-style-campaign-8d1d2c-5">
              <Typography sx={{
                    fontSize: "14px"
                  }}>End Date</Typography>
              <TextField name="endDate" type="date" value={resume_formData.endDate} onChange={handleChange} InputProps={{
                    inputProps: {
                      min: formatToIST(campaignMetaData.endDate)
                    }
                  }} margin="normal" required />         
              </div> 
              </div>
              <instruct>{`**[Previous Start Date was: ${formatDateShort(campaignMetaData.startDate)},
               & Previous End Date was: ${formatDateShort(campaignMetaData.endDate)}]`}</instruct>
  
              <Box mt={2} display="flex" justifyContent="space-evenly">
              <button className="outlined-btn" onClick={tackleRWOD}>Go with prev. dates</button>
                <button onClick={tackleCancelResume} className="outlined-btn">
                  Cancel
                </button>
                <button type="submit" className='center filled-btn'>
                  OK
                </button>
              </Box>
            </form>
          </Box>
        </Modal>
        </div> : <div className="btn-container">
            {approvalView ? <>
              <button className='outlined-btn' onClick={() => handleAction('Review Saved')}>Save</button>
              <button className='filled-btn' onClick={() => setOpenConfirmation(2)}>Approve</button>
              {isApproved ? <button className='filled-btn' onClick={() => setOpenConfirmation(4)}>Finalize</button> : <><button className='outlined-btn' onClick={() => setOpenConfirmation(5)}>Hold</button>
              </>}     
              <button className='outlined-btn' onClick={() => setOpenConfirmation(3)}>Decline</button>
            </> :
        //=========================
        <>{campaignMetaData.status !== 'On Hold' && <button className={`outlined-btn ${!enableBtns ? 'disabled' : ''}`} disabled={!enableBtns} onClick={() => setEditDates(true)}>Edit</button>}
                <Modal open={editDates} onClose={() => setEditDates(false)}>
          <Box sx={style}>
            <Typography variant="h6" component="h2" className="migrated-style-campaign-8d1d2c-6">
              Enter New dates
            </Typography>
            
            <form onSubmit={handleEditFormSubmit} className="migrated-style-campaign-8d1d2c-7">
              <div className="migrated-style-campaign-8d1d2c-8">
              <div>
              <Typography sx={{
                      fontSize: "14px"
                    }}>Start Date</Typography>
              <TextField name="startDate" type="date" value={edit_formData.startDate} onChange={handleEditFormChange} fullWidth margin="normal" InputProps={{
                      inputProps: {
                        min: weekAhead() // Set the minimum date to 5 working days from today
                      }
                    }} required />
            </div>
            <div>
            <Typography sx={{
                      fontSize: "14px"
                    }}>End Date</Typography>
              <TextField name="endDate" type="date" value={edit_formData.endDate} onChange={handleEditFormChange} fullWidth margin="normal" InputProps={{
                      inputProps: {
                        min: weekAhead() // Set the minimum date to 5 working days from today
                      }
                    }} required /> 
              </div>              
              </div>
              <Box mt={2} display="flex" justifyContent="flex-end">
              
                <button onClick={tackleCancelEdit} className="outlined-btn migrated-style-campaign-8d1d2c-9">
                  Cancel
                </button>
                <button type="submit" className='center filled-btn'>
                  Edit
                </button>
              </Box>
            </form>
          </Box>
        </Modal>

        {/* //================= */}
                <button className={`outlined-btn ${!enableBtns ? 'disabled' : ''}`} disabled={!enableBtns} onClick={() => handleAction('Saved as Draft')}>Save</button>
                <button className={`filled-btn ${!enableBtns ? 'disabled' : ''}`} disabled={!enableBtns} onClick={() => setOpenConfirmation(1)}>
                {campaignMetaData.status !== 'On Hold' ? "Submit" : "Re-Submit"}
                  </button>
                
              </>}

          </div>}


        </div>}
    </>;
};
export default Campaign;
